import React, { Component } from 'react';
import {connect} from 'react-redux';
import 'semantic-ui-css/semantic.min.css'
import {Route, Redirect, withRouter} from "react-router-dom";
import routingConfigAdmin from "config/routingConfigAdmin";
import { AdminResponsiveContainer } from "./components/AdminResponsiveContainer";
import {Loader} from "semantic-ui-react";
import {Slide, toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { tokenExpired } from "services/auth"
import { setAuthHeader } from "utils/setAuthHeader"
import {
    logOutUser
} from "services/auth"
import * as jwt from "jsonwebtoken";

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            authReady: false
        }
    }

    componentDidMount() {
        if(this.props.user.session.rights !== 'ADMIN' && this.props.user.session.rights !== 'MANAGER' )
        {
            toast.error("Accès non autorisé")
            this.setState({redirect: true})
        }

        const token = this.props.user.session.token;

        if (token !== null) {

            let decodedToken=jwt.decode(token, {complete: true});
            let dateNow = new Date();

            if(decodedToken.payload.exp < dateNow.getTime()/1000) {
                this.props.tokenExpired();
            }
            else {
                setAuthHeader(token, 'both');
                this.setState({authReady: true})
            }

        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const token = this.props.user.session.token;

        if (token !== null) {

            let decodedToken = jwt.decode(token, {complete: true});
            let dateNow = new Date();

            if (decodedToken.payload.exp < dateNow.getTime() / 1000) {
                this.props.tokenExpired();
            }
        }
    }

    render() {

        const { authReady } = this.state;
        const { user } = this.props;

        if(this.state.redirect)
        {
            return (
                <Redirect to="/home"/>
            )
        }
        else if(!authReady)
        {
            return (<Loader active/>)
        }
        else {
            return (
                <div style={{height:'100%'}}>
                    <AdminResponsiveContainer logout={this.logout} pathname={this.props.location.pathname} generalParameters={this.props.generalParameters} user={{
								rights: user.session.rights,
								name: user.session.name,
								role: user.session.role,
								gender: user.session.gender,
								nurseHelp: user.session.nurseHelp
							}}>

                        {
                            routingConfigAdmin.map((route, key) => (
                                <RouteWithSubRoutes
                                    {...route}
                                    key={key}
                                    openSidebar={this.openSidebar}
                                    hideSidebar={this.hideSidebar}
                                />)
                            )
                        }

                        { this.props.location.pathname === "/admin" &&
                        <div style={{marginTop:50, paddingLeft:20}}>Bienvenue sur le Backoffice - Silex 6</div>
                        }


                    </AdminResponsiveContainer>


                    <ToastContainer
                        position="bottom-left"
                        autoClose={10000}
                        hideProgressBar={true}
                        transition={Slide}
                    />
                </div>



            )
        }



    }
}

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={props => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} openSidebar={route.openSidebar} hideSidebar={route.hideSidebar}/>
            )}
        />
    );
}


const mapStateToProps = state => {
    return {
        user : state.user,
        generalParameters: state.generalParameters,
    }
};

const mapDispatchToProps = {
    logOutUser,
    tokenExpired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
